<template>
  <div class="form-page">
    <FormTabGuard>
      <ShortForm />
    </FormTabGuard>
  </div>
</template>
<script>
// Components
import ShortForm from '@/components/common/ShortForm/ShortForm.vue';
import FormTabGuard from '@/components/common/FormTabGuard/FormTabGuard.vue';
export default {
  name: 'ShortFormPage',
  components: {
    ShortForm,
    FormTabGuard
  }
};
</script>
